import SampleTech from 'const/enums/SampleTech';
import createMemoizedSelector from 'redux/selectors/createMemoizedSelector';
var getHasSeuratTechnology = function getHasSeuratTechnology(experimentId) {
  return function (state) {
    var _state$experiments$ex, _state$experiments$ex2;
    var sampleIds = (_state$experiments$ex = (_state$experiments$ex2 = state.experiments[experimentId]) === null || _state$experiments$ex2 === void 0 ? void 0 : _state$experiments$ex2.sampleIds) !== null && _state$experiments$ex !== void 0 ? _state$experiments$ex : state.experimentSettings.info.sampleIds;
    if (!sampleIds) return null;
    return sampleIds.some(function (sampleId) {
      var _state$samples$sample;
      return ((_state$samples$sample = state.samples[sampleId]) === null || _state$samples$sample === void 0 ? void 0 : _state$samples$sample.type) === SampleTech.SEURAT;
    });
  };
};
export default createMemoizedSelector(getHasSeuratTechnology);